<template>
  <div class="sub-header">
    <el-card
      v-for="(q, index) in data"
      :key="index"
      shadow="never"
      class="box-card"
    >
      <div slot="header">
        <span style="font-size: 15px;">{{ q.title }}</span>
        <div style="float: right">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="addRow(data, index)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="delRow(data, index)"
          ></el-button>
        </div>
      </div>
      <el-form label-width="80px">
        <el-form-item label="案例名称">
          <el-input v-model="q.name"></el-input>
        </el-form-item>
        <el-row>
          <el-col span=12>
            <el-form-item label="时间">
              <el-input v-model="q.time"></el-input>
            </el-form-item>
          </el-col>
          <el-col span=12>
            <el-form-item label="地方">
              <el-input v-model="q.location"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="公开链接">
          <el-input v-model="q.link"></el-input>
        </el-form-item>
        <el-form-item label="正文">
          <el-input type="textarea" :rows="3" v-model="q.content"></el-input>
        </el-form-item>
        <el-form-item label="案例图片">
          <q-image v-model="q.files"></q-image>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
const numbers = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
import QImage from "./QImage";
export default {
  components: { QImage },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: [
        {
          title: "案例一",
          name: "",
          time: "",
          location: "",
          content: "",
          link: "",
          files: []
        }
      ]
    };
  },
  methods: {
    addRow(q, index) {
      if (q.length < 10) {
        q.splice(index + 1, 0, {
          title: `案例${numbers[index + 1]}`,
          name: "",
          time: "",
          location: "",
          content: "",
          link: "",
          files: []
        });
        this.refreshRow(q);
      }
    },
    refreshRow(q) {
      q.forEach((e, i) => {
        e.title = `案例${numbers[i]}`;
      });
    },
    delRow(q, index) {
      if (q.length === 1) {
        console.log("delRow", index);
        q.splice(
          index,
          1,
          Object({
            title: "案例一",
            name: "",
            time: "",
            location: "",
            content: "",
            link: "",
            files: []
          })
        );
      } else {
        q.splice(index, 1);
        this.refreshRow(q);
      }
    }
  },
  watch: {
    data: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true
    }
  }
};
</script>
<style>
.box-card {
  margin-left: 1%;
  margin-right: 1%;
}
.sub-header .el-card__header {
  background: rgb(255, 255, 255);
}
.sub-header .el-form-item {
  margin-bottom: 15px;
}
.sub-header .el-card {
  border: 1px solid #DCDFE6;
  margin-bottom: 10px;
}
.sub-header .el-card__header {
  border-bottom: 1px solid #DCDFE6;
}
</style>
